
export default function CTAAbout() {
  return (
    <section className="py-16 sm:py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle, #f97316 1px, transparent 1px)',
            backgroundSize: '30px 30px',
          }}
        />
      </div>

      <div className="w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-3xl p-8 sm:p-12 md:p-16 text-center shadow-2xl border border-gray-700">
          {/* Photo small */}
          <div className="w-20 h-20 rounded-full overflow-hidden mx-auto mb-6 border-4 border-orange-500/30 shadow-lg">
            <img
              src="https://public.readdy.ai/ai/img_res/6a7b077f6d2652732b9803a7107543b4.jpg"
              alt="Marc Signorel"
              title="Marc Signorel - Expert Digital"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
            Pr\u00eat \u00e0 g\u00e9n\u00e9rer plus de leads ?
          </h2>
          <p className="text-lg sm:text-xl text-white/80 mb-8 sm:mb-10 leading-relaxed max-w-2xl mx-auto">
            Discutons de votre projet. Je vous explique comment l\u2019Usine \u00e0 Leads peut transformer votre acquisition client.
          </p>

          <a
            href="https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin"
            data-iclosed-link="https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin"
            data-embed-type="popup"
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-xl font-bold text-base sm:text-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-2xl hover:shadow-orange-500/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-block mb-6"
          >
            Prendre rendez-vous
          </a>

          <div className="flex flex-wrap items-center justify-center gap-6 pt-6 border-t border-white/10">
            <div className="flex items-center gap-2 text-white/80">
              <i className="ri-time-line text-xl text-teal-400 flex-shrink-0" />
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">R\u00e9ponse sous 24h</span>
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <i className="ri-phone-line text-xl text-orange-400 flex-shrink-0" />
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Appel d\u00e9couverte gratuit</span>
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <i className="ri-shield-check-line text-xl text-emerald-400 flex-shrink-0" />
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Sans engagement</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
